
class Filter {

     constructor(props) {
        this.props = props;

        this.onClickFilterBtn = this.onClickFilterBtn.bind(this);
        this.initialize();
    }

    initialize() {
        this.bindUI();
        this.bindEvents();
        this.initFilters();
    }

    bindUI() {
        this.ui = {};

        this.ui.$parent = this.props.el;
        this.ui.$filterBtn = this.props.el.querySelector('.js-ressources-filter-btn');
        this.ui.$filtersTriggers = this.props.el.querySelectorAll('.js-ressources-filter-trigger');
        this.ui.$filterTargets = this.props.el.querySelectorAll('.js-ressources-filter-target');
        this.ui.$filterNoResults = this.props.el.querySelector('.js-ressources-filter-noresults');
    }

    bindEvents() {
        this.ui.$filterBtn.addEventListener('click', this.onClickFilterBtn);
    }

    unbindEvents() {
        this.ui.$filterBtn.removeEventListener('click', this.onClickFilterBtn);
    }


    destroy() {
        this.unbindEvents();
    }

    initFilters() {
        this.filters = [];
        this.filterTargets = [];
        this.hasFilteredItems = true;

        [].forEach.call(this.ui.$filtersTriggers, (item) => {
            this.filters.push({
                $item: item,
                optionValues: [...item.querySelectorAll('option')].map((option) => {
                    return option.value
                }),
                filterType: item.getAttribute('data-filter-type')
            });
        });

        [].forEach.call(this.ui.$filterTargets, (item) => {
            this.filterTargets.push({
                $el: item
            });
        });
    }

    onClickFilterBtn(e) {
        e.preventDefault();

        this.filterItems();
        this.switchResults();

    }

    filterItems () {
        this.hasFilteredItems = false;

        this.filterTargets.forEach((item, index) => {

            //Parse all filters
            for (let i = 0; i < this.filters.length; i++) {
                const currentFilter = this.filters[i];

                const filterAttr = JSON.parse(item.$el.getAttribute(`data-filter-${currentFilter.filterType}`));
                const selectedIndex = currentFilter.$item.selectedIndex;

                if (!filterAttr) {
                    this.hideItem(item.$el);
                    break;
                }

                if (selectedIndex > 0 && filterAttr.indexOf(currentFilter.optionValues[selectedIndex]) < 0) {
                    this.hideItem(item.$el);
                    break;
                } else if (i == this.filters.length - 1) { //If all conditions are checked
                    this.showItem(item.$el);
                    this.hasFilteredItems = true;
                }
            }

        });
    }

    showItem (item) {
        item.classList.add('is-visible');
    }

    hideItem(item) {
        item.classList.remove('is-visible');
    }

    switchResults() {
        if (this.hasFilteredItems) {
            this.ui.$filterNoResults.classList.remove('is-visible');
        } else {
             this.ui.$filterNoResults.classList.add('is-visible');
        }
    }

}

export default Filter;
